export enum ShadowProfileEnum { 
    SALEPROFILE,
    SALEACCOUNT,
    LEADS,
    OPPORTUNITY
}